import { replayList } from "@/mocks/gua";

const catColor: Record<string, string> = {
  音乐: "bg-primary-100 text-primary-800",
  综艺: "bg-secondary-100 text-secondary-900",
  电竞: "bg-accent-100 text-accent-800",
};

export default function ReplayFeature() {
  return (
    <section id="replay" className="scroll-mt-20 bg-background-50 py-12 md:py-16">
      <div className="wrap">
        <div className="flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-900">
              <i className="ri-clipboard-line" aria-hidden="true"></i>
              系列档案 · 完整复盘
            </span>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              完整复盘档案<span className="text-accent-600">一键直达</span>
            </h2>
            <p className="mt-2 max-w-2xl text-sm text-foreground-600">
              同类事件归档成册，每条都附时间线与阶段小结。想看谁，直接翻开对应档案，脉络清清楚楚。
            </p>
          </div>
        </div>

        <div className="mt-6 flex flex-col gap-4">
          {replayList.map((r) => (
            <article
              key={r.no}
              className="group grid gap-4 overflow-hidden rounded-2xl border border-background-200 bg-background-100/50 p-3 transition-colors hover:border-accent-300 sm:p-4 md:grid-cols-[auto_1fr] md:items-stretch"
            >
              <div className="relative h-44 w-full overflow-hidden rounded-xl md:h-auto md:w-64">
                <img
                  src={r.image}
                  alt={r.title}
                  title={r.title}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-2 top-2 flex h-9 items-center rounded-lg bg-background-50/95 px-3 font-heading text-lg font-bold text-primary-600">
                  NO.{r.no}
                </span>
              </div>
              <div className="flex flex-col p-1 md:px-2 md:py-1">
                <div className="flex items-center gap-2">
                  <span className={"whitespace-nowrap rounded px-2 py-0.5 text-[11px] font-medium " + (catColor[r.cat] ?? "bg-background-200 text-foreground-700")}>
                    {r.cat}专题
                  </span>
                  <span className="inline-flex items-center gap-1 text-xs text-foreground-500">
                    <i className="ri-git-branch-line" aria-hidden="true"></i>
                    完整时间线 {r.steps} 段
                  </span>
                </div>
                <h3 className="mt-2 font-heading text-xl font-bold text-foreground-950 transition-colors group-hover:text-accent-700">
                  {r.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{r.summary}</p>
                <div className="mt-auto flex items-center justify-between border-t border-background-200 pt-3">
                  <span className="flex items-center gap-1.5 text-xs text-foreground-500">
                    <i className="ri-file-check-line text-accent-600" aria-hidden="true"></i>
                    已收录可核验节点
                  </span>
                  <a
                    href="#timeline"
                    className="inline-flex items-center gap-1 whitespace-nowrap rounded-md bg-background-50 px-4 py-2 text-sm font-medium text-foreground-800 ring-1 ring-background-300 transition-colors group-hover:bg-accent-500 group-hover:text-background-50"
                  >
                    展开复盘
                    <i className="ri-arrow-right-line" aria-hidden="true"></i>
                  </a>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}